import { clearLocalStorage } from "@/app/localStorage/utils";
import { STATUS } from "@/common/api/constants";
import {
  HandleErrorMessage,
  ResponseHandler,
  ShowOrThrowErrorMessage,
} from "@/common/api/types";
import { RouterPath } from "@/router/types";

export const getErrorMessage = async (response: Response): Promise<string> => {
  try {
    const parsedResponse = await response.json();
    if (
      typeof parsedResponse.error === "string" ||
      typeof parsedResponse.message === "string"
    ) {
      return parsedResponse.error || parsedResponse.message;
    } else {
      return "Неизвестная ошибка";
    }
  } catch {
    return "Неизвестная ошибка";
  }
};

export const handleErrorMessage: HandleErrorMessage = async ({
  response,
  setErrorMessage,
}) => {
  if (response) {
    const message = await getErrorMessage(response);
    setErrorMessage?.(message);
  }
};

const showOrThrowErrorMessage: ShowOrThrowErrorMessage = async ({
  setErrorMessage,
  response,
}) => {
  const message = await getErrorMessage(response);

  if (setErrorMessage) {
    setErrorMessage(message);
  } else {
    throw new Error(message);
  }
};

export const responseHandler: ResponseHandler = async ({
  response,
  setErrorMessage,
  customHandler,
}) => {
  if (response.status === STATUS.UNAUTHORIZED) {
    clearLocalStorage();
    window.location.replace(RouterPath.Login);
    return response;
  }
  if (response.status === STATUS.UNPROCESSABLE_ENTITY) {
    await customHandler?.({ response, setErrorMessage });
    return response;
  }
  if (response.status === STATUS.REJECTED) {
    clearLocalStorage();
    window.location.replace("/rejected");
    return response;
  }
  if (response.status === STATUS.UNAVAILABLE) {
    const data = await response.json();
    sessionStorage.setItem("partners", JSON.stringify(data));
    clearLocalStorage();

    window.location.replace("/partners");
    return response;
  }
  if (response.status >= STATUS.CLIENT_ERRORS) {
    showOrThrowErrorMessage({ response, setErrorMessage });
    return response;
  }
  if (response.status >= STATUS.SERVER_ERRORS) {
    showOrThrowErrorMessage({ response, setErrorMessage });
    return response;
  }
  return response;
};
